var exports = {
  "kL": "x31de4314--941b29--container",
  "nf": "x31de4314--941b29--link",
  "VH": "x31de4314--941b29--preview",
  "q9": "x31de4314--941b29--price",
  "Qs": "x31de4314--941b29--content",
  "hl": "x31de4314--941b29--address",
  "O7": "x31de4314--941b29--link-newbuilding",
  "wm": "x31de4314--941b29--logo",
};

module.exports = exports;
